import type { ROUTES } from "@/constants/routes";

import { matchPath, useLocation } from "react-router-dom";

type TUseIsRouteIncluded = (typeof ROUTES)[keyof typeof ROUTES][];

function useIsRouteIncluded(routes: TUseIsRouteIncluded) {
  const location = useLocation();

  return routes.some((route) => {
    return !!matchPath(route, location.pathname);
  });
}

export default useIsRouteIncluded;
